import { SearchViewProps } from 'supplier-portals/uxbeauty/pages/Search/SearchViewProps';
import {
  SearchResults,
  SearchSort,
  SearchSortField,
  SearchTarget
} from 'types/Search';

export type SearchViewPropsExtended<T extends object> = SearchViewProps & {
  searchResults: SearchResults;
  onLoadMore: () => void;
  target: SearchTarget;
  setShowRegisterModal?: (a: boolean) => void;
  loading: boolean;
  error: boolean;
  logItemClick: (document: T) => void;
  onSelectedChange: (document: T, selected: boolean) => void;
  onBookmarkChange?: (document: T, bookmarked: boolean) => void;
  sortOption: SearchSort[];
  handleSortChange: (option: { value: SearchSortField }) => void;
  resetListState?: boolean;
};

export const BOOKMARK_SIZE = 5;
